import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';
import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';

interface UseUpdateFact {
  field: string;
  value: string;
  factId: string;
}

const useUpdateFact = (matterId: string, subsetId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ field, value, factId }: UseUpdateFact) => {
      const fetchConfig = getFetchConfig({ method: FetchMethod.PATCH, data: { [field]: value } });
      trackCustomEvent(TrackingEventsV2.FactUpdateContent, { field });
      return fetch(`${APIBaseChronos}/api/matter/${matterId}/fact/${subsetId}/${factId}`, fetchConfig);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [QueryEntity.SubsetFacts, { subsetId }] });
        queryClient.invalidateQueries({ queryKey: [QueryEntity.SubsetFactAllIds, { subsetId }] });
        toast.success('Fact successfully updated');
      },
      onError: () => {
        toast.error('Failed to update field');
      },
    },
  );
};

export default useUpdateFact;
